import 'moment-timezone';
import each from 'lodash/each';
import fill from 'lodash/fill';
import filter from 'lodash/filter';
import forEach from 'lodash/forEach';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import moment from 'moment';
import numeral from 'numeral';
import React, { Component } from 'react';
import reduce from 'lodash/reduce';
import tools from 'utils/tools';
/** import third-party libraries in the section above, Sort Lines Ascending */

import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
/** import mui components in the section above, Sort Lines Ascending */

import { BodyBold } from 'widgets-v5/typography';
import { IncludeExcludeLayout } from 'widgets-v6/layout';
import { SummaryGroup, SummaryLayout } from 'widgets/summary-view/summary-layout';
import Spacer from 'widgets-v5/spacer';
import SummaryTypeGeoTargeting from 'widgets/summary-view/summary-type-geo-targeting';
import SummaryTypePublisherTargeting from 'widgets/summary-view/summary-type-dooh-publisher-targeting';
import SummaryTypeText from 'widgets/summary-view/summary-type-text';
import SummaryTypeTextCollection from 'widgets/summary-view/summary-type-text-collection';
/** import widgets components in the section above, Sort Lines Ascending */

import {
    canAdPresetFieldBeUsed,
    couldAdPresetHaveRestrictions,
} from 'states/resources/ad-presets/business-logic';
import {
    getTargetCarriersExclude,
    getTargetCarriersInclude,
} from 'common/constants/carrier-targeting-v2';
/** import multi application imports in the section above, Sort Lines Ascending */

import { applyAdPresetPropertyDisplayNames } from 'services/resources/ad-preset';
import { DeviceOSMapping } from 'states/resources/ads/business-logic';
import { getEnvironmentSettings } from 'services/environment';
import { TargetCarriersIspsSummary } from 'forms/ad-form/modules/target-carriers-isps';
import LANGUAGE_CODES from 'common/constants/language-codes';
/** import single application imports in the section above, Sort Lines Ascending */

const getAgeGroups = values => {
    // Reuse code from v2
    function _formatAgeGroup(val) {
        if (!val) return '';

        let out;
        if (val.length === 0 || val.length === 7) {
            out = ['Everyone'];
        } else {
            const displayTextArray = [];
            forEach(val, function(item) {
                switch (item) {
                    case 2:
                        displayTextArray.push('19-24');
                        break;
                    case 3:
                        displayTextArray.push('25-34');
                        break;
                    case 4:
                        displayTextArray.push('35+');
                        break;
                    case 5:
                        displayTextArray.push('35-44');
                        break;
                    case 6:
                        displayTextArray.push('45-54');
                        break;
                    case 7:
                        displayTextArray.push('55-64');
                        break;
                    case 8:
                        displayTextArray.push('65+');
                        break;
                    case -1:
                        displayTextArray.push('Unknown');
                        break;
                    default:
                        throw new Error(
                            'Age group array is not empthy and contains unregonize value'
                        );
                }
                out = displayTextArray;
            });
        } // End else
        return out;
    }

    return _formatAgeGroup(values);
};

const getGenders = values => {
    // Reuse code from v2
    function _formatTargetGenders(val) {
        if (isArray(val)) {
            if (val.length === 0 || val.length === 3) {
                return 'Everyone';
            } else {
                const displayTextArray = [];
                forEach(val, function(item) {
                    if (item === 'M') {
                        displayTextArray.push('Male');
                    } else if (item === 'F') {
                        displayTextArray.push('Female');
                    } else if (item === 'D') {
                        displayTextArray.push('Unknown');
                    } else {
                        throw new Error('Gender array is not empthy and contains unregonize value');
                    }
                });
                return displayTextArray.join(', ');
            } // End else
        }
    }

    return _formatTargetGenders(values);
};

const getDeviceOs = values => {
    function _formatDeviceOs(val) {
        let displayTextArray = [];
        if (isArray(val)) {
            if (val.length === 0) {
                displayTextArray = [
                    DeviceOSMapping.IOS,
                    DeviceOSMapping.Android,
                    DeviceOSMapping.BlackBerry,
                ];
                return displayTextArray.join(', ');
            } else {
                return val.join(', ');
            } // End else
        }
    }
    return _formatDeviceOs(values);
};

export const getDayPart = (dayparts, timezone, adStart) => {
    if (dayparts.value.length < 1) return ['Full Day'];

    const formattedTimezone = moment(adStart)
        .tz(timezone)
        .format('z');
    const dateAsYearMonthDay = adStart.slice(0, 10);

    const createOutputString = (start, end) =>
        `${start.hour}:${start.minute} ~ ${end.hour}:${end.minute} ${
            dayparts.field === 'dayparts' ? formattedTimezone : 'Local Time'
        }`;

    function createMergedTimeranges(timeranges) {
        function getSelectedTimeBlocks(_dayparts, _timezone) {
            const selectedTimeblocks = [];
            selectedTimeblocks.length = 96;
            fill(selectedTimeblocks, false);

            _dayparts.forEach(daypart => {
                const startMoment = moment
                    .utc(`${dateAsYearMonthDay}T${daypart.start}Z`)
                    .tz(_timezone);
                const endMoment = moment.utc(`${dateAsYearMonthDay}T${daypart.end}Z`).tz(_timezone);

                const startIndex =
                    startMoment.hours() * 4 +
                    (startMoment.minutes() >= 15 ? 1 : 0) +
                    (startMoment.minutes() >= 30 ? 1 : 0) +
                    (startMoment.minutes() >= 45 ? 1 : 0);

                const endIndex =
                    endMoment.hours() * 4 +
                    (endMoment.minutes() >= 15 ? 1 : 0) +
                    (endMoment.minutes() >= 30 ? 1 : 0) +
                    (endMoment.minutes() >= 45 ? 1 : 0);

                fill(selectedTimeblocks, true, startIndex, endIndex + 1);
            });
            return selectedTimeblocks;
        }

        function getContinuousTrueValues(array) {
            const startEndPairs = [];
            let trueStartIndex = null;
            let inTrueRange = false;
            array.forEach((value, index) => {
                if (value && !inTrueRange) {
                    trueStartIndex = index;
                    inTrueRange = true;
                }
                if (!value && inTrueRange) {
                    startEndPairs.push({
                        start: trueStartIndex,
                        end: index - 1,
                    });
                    trueStartIndex = null;
                    inTrueRange = false;
                }
                // If last item
                if (index === array.length - 1 && inTrueRange) {
                    startEndPairs.push({
                        start: trueStartIndex,
                        end: index,
                    });
                }
            });
            return startEndPairs;
        }

        function createTimeBlocks() {
            const timeblocks = [];
            for (let i = 0; i < 24; i++) {
                const blocks = [
                    {
                        label: `${i}`,
                        start: { hour: i, minute: '00', second: '00' },
                        end: { hour: i, minute: '14', second: '59' },
                    },
                    {
                        label: '',
                        start: { hour: i, minute: '15', second: '00' },
                        end: { hour: i, minute: '29', second: '59' },
                    },
                    {
                        label: '',
                        start: { hour: i, minute: '30', second: '00' },
                        end: { hour: i, minute: '44', second: '59' },
                    },
                    {
                        label: '',
                        start: { hour: i, minute: '45', second: '00' },
                        end: { hour: i, minute: '59', second: '59' },
                    },
                ];
                timeblocks.push(...blocks);
            }
            return timeblocks;
        }

        function make2Digits(n) {
            n.hour = n.hour > 9 ? '' + n.hour : '0' + n.hour;
            return n;
        }

        const selectedTimeblocks = getSelectedTimeBlocks(timeranges, timezone);
        const startEndIndexes = getContinuousTrueValues(selectedTimeblocks);
        const timeBlocksWithTimes = createTimeBlocks();

        const startEndBlocks = startEndIndexes.map(({ start: startIndex, end: endIndex }) => ({
            start: make2Digits(timeBlocksWithTimes[startIndex].start),
            end: make2Digits(timeBlocksWithTimes[endIndex].end),
        }));

        return startEndBlocks;
    }

    const mergedTimeranges = createMergedTimeranges(dayparts.value);
    const formattedRanges = map(mergedTimeranges, item => createOutputString(item.start, item.end));
    return formattedRanges;
};

const getDeviceLanguage = obj => {
    if (isArray(obj) && isEmpty(obj)) {
        return 'All Languages';
    }
    return isArray(obj) ? map(obj, item => LANGUAGE_CODES[item]).join(', ') : 'All Languages';
};

/**
 * Formats excluded device language codes for the ad-preset summary.
 * Empty exclude lists display as "None" (unlike include, which shows "All Languages").
 *
 * @param {string[]|*} obj - ISO 639-1 language codes from `target_device_language_exclude`
 * @returns {string}
 */
const getDeviceLanguageExclude = obj => {
    if (isArray(obj) && isEmpty(obj)) {
        return 'None';
    }
    return isArray(obj) ? map(obj, item => LANGUAGE_CODES[item]).join(', ') : 'None';
};

const getGeofencingOld = obj => {
    if (!obj) return [];

    return obj.map(function(box) {
        const shorter = {};
        each(box, function(val, key) {
            if (key !== 'type') {
                shorter[key] = val.toFixed(2);
            }
        });
        return `E: ${shorter.E}, W: ${shorter.W}, S: ${shorter.S}, N: ${shorter.N}`;
    });
};

const format$ = val => {
    if (tools.isLikeNumberComma(val)) {
        return numeral(val).format('$0,0.00[000000]');
    } else {
        return val;
    }
};

function formatFormData(formData) {
    return reduce(
        formData,
        (result, value, key) => {
            switch (key) {
                case 'max_cpm_rate_local':
                    result[key] = format$(value);
                    break;
                case 'geoboxes':
                    result[key] = getGeofencingOld(value);
                    break;
                case 'target_device_os':
                    result[key] = getDeviceOs(value);
                    break;
                case 'target_carriers':
                    result[key] = getTargetCarriersInclude(value);
                    break;
                case 'carriers_exclude':
                    result[key] = getTargetCarriersExclude(value);
                    break;
                case 'target_device_language':
                    result[key] = getDeviceLanguage(value);
                    break;
                case 'target_device_language_exclude':
                    result[key] = getDeviceLanguageExclude(value);
                    break;
                case 'target_genders':
                    result[key] = getGenders(value);
                    break;
                case 'target_age_groups':
                    result[key] = getAgeGroups(value);
                    break;
                default:
                    result[key] = value;
            }
            return result;
        },
        {}
    );
}

class AdSummary extends Component {
    /**
     * Tooltip when a checked preset property will not apply (platform, PG, and/or bid mode).
     *
     * @param {string[]} adPlatforms
     * @param {Object} [options]
     * @param {boolean} [options.isGuaranteedInventoryOnly] - True when platforms allow the field
     *   but guaranteed inventory blocks it (use PG copy instead of platform list)
     * @param {boolean} [options.bidModeOnly] - True when Total Bid is blocked because the ad is not Fixed bid
     * @returns {JSX.Element}
     */
    tooltipUnavailableField(
        adPlatforms,
        { isGuaranteedInventoryOnly = false, bidModeOnly = false } = {}
    ) {
        let title;
        if (bidModeOnly) {
            title =
                'Total Bid Price only applies when the ad uses Fixed bid price. It is not available for automatic bid.';
        } else if (isGuaranteedInventoryOnly) {
            title = 'This field is not compatible with guaranteed inventory';
        } else {
            title = `This field is not compatible with ${adPlatforms.join(', ')} platforms`;
        }

        return (
            <Tooltip
                title={<Typography variant="body2">{title}</Typography>}
                placement="left"
                style={{ color: 'gray' }}
            >
                <i className="fa fa-question-circle" />
            </Tooltip>
        );
    }

    tooltipPartialField(adPlatforms) {
        return (
            <Tooltip
                title={
                    <Typography variant="body2">
                        Only values compatible with {adPlatforms.join(', ')} will be applied
                    </Typography>
                }
                placement="left"
                style={{ color: 'gray' }}
            >
                <i className="fa fa-info-circle" />
            </Tooltip>
        );
    }

    /**
     * Tooltip for geotargets on PG: countries still apply; city/region/FSA lists do not.
     *
     * @returns {JSX.Element}
     */
    tooltipGuaranteedGeoLocationsOnly() {
        return (
            <Tooltip
                title={
                    <Typography variant="body2">
                        City, region, and FSA include/exclude will not be applied for guaranteed
                        inventory. Only countries will be applied.
                    </Typography>
                }
                placement="left"
                style={{ color: 'gray' }}
            >
                <i className="fa fa-question-circle" />
            </Tooltip>
        );
    }

    /**
     * Returns a restriction tooltip for a checked preset property, or null when fully applicable.
     *
     * @param {boolean} adPresetMayHaveRestrictions
     * @param {string[]} adPlatforms
     * @param {string} field - Property key (e.g. `geotargets`, `target_carriers`)
     * @returns {JSX.Element|null}
     */
    getFieldTooltip(adPresetMayHaveRestrictions, adPlatforms, field) {
        const isGuaranteedInventory = Boolean(this.props.isGuaranteedInventory);
        const bidStrategyMode = this.props.bidStrategyMode;
        const environmentSettings = getEnvironmentSettings();
        const gateOptions = {
            isGuaranteedInventory,
            ...(bidStrategyMode !== undefined ? { bidStrategyMode } : {}),
            environmentSettings,
        };
        // Bid mode can block Total Bid even when platforms alone would allow CPM
        const bidModeBlocksTotalBid =
            field === 'max_cpm_rate_local' &&
            bidStrategyMode !== undefined &&
            bidStrategyMode !== 'fixed_bid_price';
        const availableForPlatforms = canAdPresetFieldBeUsed(adPlatforms, field, {
            environmentSettings,
        });
        const availableWithoutBidMode = canAdPresetFieldBeUsed(adPlatforms, field, {
            isGuaranteedInventory,
            environmentSettings,
        });
        // Always evaluate gates so env (and other) unavailability surfaces even when
        // platforms alone would not trigger couldAdPresetHaveRestrictions.
        const isFieldAvailable = canAdPresetFieldBeUsed(adPlatforms, field, gateOptions);

        if (!isFieldAvailable) {
            if (bidModeBlocksTotalBid && availableWithoutBidMode) {
                return this.tooltipUnavailableField(adPlatforms, { bidModeOnly: true });
            }
            // Prefer PG-specific copy when platforms would allow the field but inventory type blocks it
            return this.tooltipUnavailableField(adPlatforms, {
                isGuaranteedInventoryOnly: isGuaranteedInventory && availableForPlatforms,
            });
        }
        if (
            field === 'target_device_os' &&
            (adPlatforms.includes('ctv') || adPlatforms.includes('dooh'))
        ) {
            return this.tooltipPartialField(adPlatforms);
        }

        return null;
    }

    render() {
        const { formData, adPlatforms, isGuaranteedInventory } = this.props;
        if (!formData) {
            return <div>loading... </div>;
        }
        const formatedFormData = formatFormData(formData);
        const adPresetPropertiesForSummary = applyAdPresetPropertyDisplayNames(
            formatedFormData.ad_preset_properties
        );
        const adPresetMayHaveRestrictions = couldAdPresetHaveRestrictions(adPlatforms);

        return (
            <SummaryLayout hiddinHeaderText={this.props.hiddinHeaderText} title="Summary">
                <BodyBold>
                    {formData.ad_preset_name ? formData.ad_preset_name : <span>&nbsp;</span>}
                </BodyBold>
                <Spacer type="small" />
                {map(adPresetPropertiesForSummary, (group, index) => {
                    const summaryList = map(
                        filter(group.properties, property => property.checked === true),
                        (prop, index) => {
                            switch (prop.key) {
                                case 'geotargets': {
                                    const tooltip = this.getFieldTooltip(
                                        adPresetMayHaveRestrictions,
                                        adPlatforms,
                                        prop.key
                                    );
                                    const geotargets = formatedFormData.geotargets || [];
                                    // PG apply strips city/region/FSA — strike include/exclude in summary and explain via tooltip
                                    const hasIncludeExcludeLocations = geotargets.some(
                                        gt =>
                                            (Array.isArray(gt.include) && gt.include.length > 0) ||
                                            (Array.isArray(gt.exclude) && gt.exclude.length > 0)
                                    );
                                    const allowIncludeExclude = !isGuaranteedInventory;
                                    const geoTooltip =
                                        isGuaranteedInventory && hasIncludeExcludeLocations
                                            ? this.tooltipGuaranteedGeoLocationsOnly()
                                            : tooltip;

                                    return (
                                        <SummaryTypeGeoTargeting
                                            key={prop.key + index}
                                            keyName={prop.name}
                                            value={geotargets}
                                            allowIncludeExclude={allowIncludeExclude}
                                            // Opt out of highlight HOC — JSON.stringify crashes on React element values
                                            allowHighlight={false}
                                            strikethroughText={!!tooltip}
                                            tooltip={geoTooltip}
                                        />
                                    );
                                }
                                case 'target_dooh_publishers': {
                                    if (!getEnvironmentSettings().canUseCTVOrDOOH()) {
                                        return null;
                                    }
                                    const tooltip = this.getFieldTooltip(
                                        adPresetMayHaveRestrictions,
                                        adPlatforms,
                                        prop.key
                                    );
                                    return (
                                        <SummaryTypePublisherTargeting
                                            key={prop.key + index}
                                            keyName={prop.name}
                                            value={{
                                                include: formatedFormData.target_dooh_publishers,
                                                exclude:
                                                    formatedFormData.target_dooh_publishers_exclude,
                                            }}
                                            doohPublishers={this.props.doohPublishers}
                                            allowHighlight={false}
                                            strikethroughText={!!tooltip}
                                            tooltip={tooltip}
                                        />
                                    );
                                }
                                case 'target_carriers': {
                                    const tooltip = this.getFieldTooltip(
                                        adPresetMayHaveRestrictions,
                                        adPlatforms,
                                        prop.key
                                    );
                                    return (
                                        <SummaryTypeText
                                            key={prop.key + index}
                                            keyName={prop.name}
                                            value={
                                                <TargetCarriersIspsSummary
                                                    carrierISPIncludeValue={
                                                        formatedFormData.target_carriers ||
                                                        'All carriers / ISPs'
                                                    }
                                                    carrierISPExcludeValue={
                                                        formatedFormData.carriers_exclude || 'None'
                                                    }
                                                />
                                            }
                                            allowHighlight={false}
                                            strikethroughText={!!tooltip}
                                            tooltip={tooltip}
                                        />
                                    );
                                }
                                case 'target_device_language': {
                                    const tooltip = this.getFieldTooltip(
                                        adPresetMayHaveRestrictions,
                                        adPlatforms,
                                        prop.key
                                    );
                                    return (
                                        <SummaryTypeText
                                            key={prop.key + index}
                                            keyName={prop.name}
                                            value={
                                                <React.Fragment>
                                                    <IncludeExcludeLayout
                                                        type="Include"
                                                        marginBottom
                                                    >
                                                        {formatedFormData.target_device_language ||
                                                            'All Languages'}
                                                    </IncludeExcludeLayout>
                                                    <IncludeExcludeLayout type="Exclude">
                                                        {formatedFormData.target_device_language_exclude ||
                                                            'None'}
                                                    </IncludeExcludeLayout>
                                                </React.Fragment>
                                            }
                                            allowHighlight={false}
                                            strikethroughText={!!tooltip}
                                            tooltip={tooltip}
                                        />
                                    );
                                }
                                case 'geoboxes':
                                case 'target_age_groups': {
                                    const tooltip = this.getFieldTooltip(
                                        adPresetMayHaveRestrictions,
                                        adPlatforms,
                                        prop.key
                                    );

                                    return (
                                        <SummaryTypeTextCollection
                                            key={prop.key + index}
                                            keyName={prop.name}
                                            values={formatedFormData[prop.key]}
                                            allowHighlight={false}
                                            strikethroughText={!!tooltip}
                                            tooltip={tooltip}
                                        />
                                    );
                                }
                                default: {
                                    const tooltip = this.getFieldTooltip(
                                        adPresetMayHaveRestrictions,
                                        adPlatforms,
                                        prop.key
                                    );

                                    return (
                                        <SummaryTypeText
                                            key={prop.key + index}
                                            keyName={prop.name}
                                            value={formatedFormData[prop.key]}
                                            allowHighlight={false}
                                            strikethroughText={!!tooltip}
                                            tooltip={tooltip}
                                        />
                                    );
                                }
                            }
                        }
                    );

                    if (!summaryList.length) {
                        return;
                    }

                    return (
                        <SummaryGroup key={group.groupName + index} groupName={group.groupName}>
                            {summaryList}
                        </SummaryGroup>
                    );
                })}
            </SummaryLayout>
        );
    }
}

export default AdSummary;
